var map = {
	"./Birthday-cake-with-flowers.png": 9304,
	"./Ice-Cream-Cup.png": 3311,
	"./Sandwich1.png": 1020,
	"./Strawberries & Cream - Tubzee Ice Cream.jfif": 8039,
	"./amaranthus 1 bunch - vegetables.jpg": 6384,
	"./apple.jfif": 761,
	"./apple1.jfif": 7150,
	"./baby kiwi - fruits.jpg": 9628,
	"./basmati-rice-png.png": 6885,
	"./beetroot - vegetables.jpg": 3863,
	"./birthday-cake-png-clip-art-birthday-cake-.png": 8319,
	"./burger-king-whopper-with-cheese-png-image-purepng-20.png": 401,
	"./cabbage per pc - vegetables.jpg": 8574,
	"./cake.png": 3410,
	"./cake1.png": 913,
	"./carrot red per kg - vegetables.jpg": 9434,
	"./cauliflower 1 pc - vegetables.jpg": 7086,
	"./chicken-category.png": 1232,
	"./chocolate-ice-cream-sundae-neapolitan-ice-cream-ice-cream-cream-food-frozen-dessert-thumbnail.png": 39,
	"./classic-cheeseburger-with-beef-patty-pickles-cheese-tomato-onion-lettuce-and-ketchup-mustard-free-png.webp": 5523,
	"./coriander bunch 50g 200g - vegetables.jpg": 5505,
	"./cowpea beans 500g - vegetables.jpg": 3113,
	"./dosa-masala.png": 2843,
	"./dragonfruit - fruits.jpg": 363,
	"./fresh-yellow-banana-fruit-free.png": 6181,
	"./fruits.jfif": 3738,
	"./garlic peeled - vegetables.jpg": 5068,
	"./ginger 200g - vegetables.jpg": 5606,
	"./green capsicum 500.jpg": 77,
	"./green peas - vegetables.jpg": 9041,
	"./ice-cream-bowl-image.png": 9535,
	"./ice-cream-images.png": 6797,
	"./ice-cream.png": 7308,
	"./indian garlic  - 200g - vegetables.jpg": 2184,
	"./logo.png": 9819,
	"./mango-png-image-mongo-clipart-ripening-of-mango.png": 9709,
	"./mongo-clipart-gourd-transparent-png.png": 1627,
	"./mongo.png": 7500,
	"./musk melon - fruits.jpg": 3045,
	"./noodles.png": 4532,
	"./onion 5 kg - vegetables.jpg": 4311,
	"./orange1.jfif": 8920,
	"./paneer-category.png": 7712,
	"./paneer-tikka.png": 8046,
	"./pepperoni-pizza-chicago-style-pizza-italian-cuisine-breakfast-oven-pizza-food-baking-plate.png": 9208,
	"./pineapple-fruit-tropical-fruit-natural-foods-ananas-ananas.png": 4149,
	"./pineapple.jfif": 231,
	"./pizza-category.png": 1605,
	"./pizza-hut-pizza.png": 5651,
	"./png-transparent-flatbread-with-dip-dosa-chutney-indian-cuisine-crepe-idli-rice-food-recipe-cuisine.png": 509,
	"./png-transparent-pasta-spaghetti-with-meatballs-italian-cuisine-cyborg-noodle-food-recipe-american-food.png": 1644,
	"./potato per kg - vegetables.jpg": 2775,
	"./red capsicum 200g - vegetables.jpg": 7240,
	"./rice-bowl-rice.png": 8660,
	"./sandwich-sandwich.png": 3459,
	"./sharad seedless grapes 500 - fruits.jpg": 6136,
	"./spring onion per bunch - vegetables.jpg": 2970,
	"./thai guava 2 pcs - fruits.jpg": 7482,
	"./thali-menu-veg-thali.png": 8716,
	"./watermelon - fruits.jpg": 4080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 325;